var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartP7({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119.905,
    height: 23,
    viewBox: "0 0 119.905 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138446",
    "data-name": "Rectangle 138446",
    width: 15,
    height: 23,
    transform: "translate(1232 1116)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50041",
    "data-name": "Group 50041",
    transform: "translate(-983 -1120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93816",
    "data-name": "Path 93816",
    d: "M12.727,2.583l1.765,5.433a.843.843,0,0,0,.8.582h5.712a.843.843,0,0,1,.5,1.525L16.88,13.48a.843.843,0,0,0-.306.942l1.765,5.433a.843.843,0,0,1-1.3.942L12.42,17.44a.842.842,0,0,0-.991,0L6.809,20.8a.843.843,0,0,1-1.3-.942l1.765-5.433a.843.843,0,0,0-.306-.942L2.349,10.122a.843.843,0,0,1,.5-1.525H8.556a.843.843,0,0,0,.8-.582l1.765-5.433A.843.843,0,0,1,12.727,2.583Z",
    transform: "translate(981 1120)",
    fill: "#fca90d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93817",
    "data-name": "Path 93817",
    d: "M12.727,2.583l1.765,5.433a.843.843,0,0,0,.8.582h5.712a.843.843,0,0,1,.5,1.525L16.88,13.48a.843.843,0,0,0-.306.942l1.765,5.433a.843.843,0,0,1-1.3.942L12.42,17.44a.842.842,0,0,0-.991,0L6.809,20.8a.843.843,0,0,1-1.3-.942l1.765-5.433a.843.843,0,0,0-.306-.942L2.349,10.122a.843.843,0,0,1,.5-1.525H8.556a.843.843,0,0,0,.8-.582l1.765-5.433A.843.843,0,0,1,12.727,2.583Z",
    transform: "translate(1005.871 1120)",
    fill: "#fca90d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93818",
    "data-name": "Path 93818",
    d: "M12.727,2.583l1.765,5.433a.843.843,0,0,0,.8.582h5.712a.843.843,0,0,1,.5,1.525L16.88,13.48a.843.843,0,0,0-.306.942l1.765,5.433a.843.843,0,0,1-1.3.942L12.42,17.44a.842.842,0,0,0-.991,0L6.809,20.8a.843.843,0,0,1-1.3-.942l1.765-5.433a.843.843,0,0,0-.306-.942L2.349,10.122a.843.843,0,0,1,.5-1.525H8.556a.843.843,0,0,0,.8-.582l1.765-5.433A.843.843,0,0,1,12.727,2.583Z",
    transform: "translate(1030.29 1120)",
    fill: "#fca90d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93819",
    "data-name": "Path 93819",
    d: "M12.727,2.583l1.765,5.433a.843.843,0,0,0,.8.582h5.712a.843.843,0,0,1,.5,1.525L16.88,13.48a.843.843,0,0,0-.306.942l1.765,5.433a.843.843,0,0,1-1.3.942L12.42,17.44a.842.842,0,0,0-.991,0L6.809,20.8a.843.843,0,0,1-1.3-.942l1.765-5.433a.843.843,0,0,0-.306-.942L2.349,10.122a.843.843,0,0,1,.5-1.525H8.556a.843.843,0,0,0,.8-.582l1.765-5.433A.843.843,0,0,1,12.727,2.583Z",
    transform: "translate(1054.709 1120)",
    fill: "#fca90d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93820",
    "data-name": "Path 93820",
    d: "M12.727,2.583l1.765,5.433a.843.843,0,0,0,.8.582h5.712a.843.843,0,0,1,.5,1.525L16.88,13.48a.843.843,0,0,0-.306.942l1.765,5.433a.843.843,0,0,1-1.3.942L12.42,17.44a.842.842,0,0,0-.991,0L6.809,20.8a.843.843,0,0,1-1.3-.942l1.765-5.433a.843.843,0,0,0-.306-.942L2.349,10.122a.843.843,0,0,1,.5-1.525H8.556a.843.843,0,0,0,.8-.582l1.765-5.433A.843.843,0,0,1,12.727,2.583Z",
    transform: "translate(1080.032 1120.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_13",
    "data-name": "Mask Group 13",
    transform: "translate(-155 4)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93821",
    "data-name": "Path 93821",
    d: "M12.727,2.583l1.765,5.433a.843.843,0,0,0,.8.582h5.712a.843.843,0,0,1,.5,1.525L16.88,13.48a.843.843,0,0,0-.306.942l1.765,5.433a.843.843,0,0,1-1.3.942L12.42,17.44a.842.842,0,0,0-.991,0L6.809,20.8a.843.843,0,0,1-1.3-.942l1.765-5.433a.843.843,0,0,0-.306-.942L2.349,10.122a.843.843,0,0,1,.5-1.525H8.556a.843.843,0,0,0,.8-.582l1.765-5.433A.843.843,0,0,1,12.727,2.583Z",
    transform: "translate(1235.032 1116)",
    fill: "#fca90d",
    stroke: "#fca90d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartP7);
export default __webpack_public_path__ + "static/media/start-p7.d465c0fc29c97962517ad85c06fdb2e8.svg";
export { ForwardRef as ReactComponent };